import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { useListLearningMaterialsFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { WellKnownLearningMaterialCategory } from "UIPalette/LearningMaterials/wellKnownLearningMaterials";
import { ResourceCard } from "UIPalette/ResourceCard/ResourceCard";
import { selectedInterestPrefix } from "core/helpers/preferencesFilter";

export const useLearningMaterialResourceModule = (
  category: WellKnownLearningMaterialCategory,
  subCategory: string,
  isMobile: boolean | undefined
) => {
  const navigate = useNavigate();

  const { data, isLoading, error, mutate } = useListLearningMaterialsFunctionRequest(
    { categories: [category.id], subCategories: [subCategory] },
    { revalidateOnMountIfStale: false, showErrorIfStale: false }
  );

  const cards = useMemo(
    () =>
      data?.map((item) => (
        <ResourceCard key={item.id} item={item} navigateBasePath={`/${category.path}/`} className={classNames({ "min-w-[300px]": isMobile })} />
      )),
    [data, isMobile, category.path]
  );

  return {
    cards,
    isLoading,
    error,
    mutate,
    onSeeAllClick: () => navigate(`/${category.path}#${selectedInterestPrefix}${subCategory}`),
  };
};
